/*
 * GUMELLA — Contadores 2.0
 * Salvar em assets/gumella-percentuais.js.
 * Carregar uma vez pelo layout/theme.liquid, com defer.
 * Sem dependencias. Compativel com secoes inseridas/recriadas pelo editor.
 */
(function () {
  'use strict';

  if (window.GumellaPercentuaisV2) {
    window.GumellaPercentuaisV2.refresh();
    return;
  }

  var ROOT = '[data-gm-survey="2"]';
  var COUNTER = '[data-gm-count-to]';
  var states = new Map();
  var waiting = new Set();
  var checkFrame = 0;
  var booted = false;
  var intersection = null;
  var mutations = null;
  var motion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var requestFrame = window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (fn) {
    return window.setTimeout(function () { fn(Date.now()); }, 16);
  };
  var cancelFrame = window.cancelAnimationFrame ? window.cancelAnimationFrame.bind(window) : window.clearTimeout.bind(window);

  function limitedNumber(value, fallback, max) {
    var parsed = Number(value);
    return value == null || !Number.isFinite(parsed) ? fallback : Math.min(max, Math.max(0, parsed));
  }

  function write(state, value) {
    var text = String(value);
    if (state.node.textContent !== text) state.node.textContent = text;
  }

  function finish(state) {
    if (state.frame) cancelFrame(state.frame);
    state.frame = 0;
    state.phase = 'complete';
    waiting.delete(state);
    if (intersection) intersection.unobserve(state.node);
    write(state, state.target);
    state.node.setAttribute('data-gm-counter-state', 'complete');
  }

  function remove(state) {
    if (state.frame) cancelFrame(state.frame);
    if (intersection) intersection.unobserve(state.node);
    waiting.delete(state);
    states.delete(state.node);
  }

  function inView(state) {
    if (!state.node.isConnected || document.hidden) return false;
    var rect = state.node.getBoundingClientRect();
    var height = window.innerHeight || document.documentElement.clientHeight;
    var width = window.innerWidth || document.documentElement.clientWidth;
    if (rect.width <= 0 || rect.height <= 0 || rect.bottom <= 24 || rect.top >= height - 24 || rect.right <= 0 || rect.left >= width) return false;
    // Nao iniciar por tras de uma secao oculta ou antes de um efeito de entrada.
    for (var parent = state.node; parent && parent.nodeType === 1; parent = parent.parentElement) {
      var style = window.getComputedStyle(parent);
      if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || Number(style.opacity) === 0) return false;
    }
    return true;
  }

  function start(state) {
    if (state.phase !== 'waiting' || !state.node.isConnected) return;
    if (motion && motion.matches) { finish(state); return; }
    state.phase = 'running';
    state.node.setAttribute('data-gm-counter-state', 'running');
    waiting.delete(state);
    if (intersection) intersection.unobserve(state.node);
    var firstTime = null;

    function tick(time) {
      if (!state.node.isConnected) { remove(state); return; }
      if (motion && motion.matches) { finish(state); return; }
      if (firstTime === null) firstTime = time;
      var progress = Math.min(1, Math.max(0, (time - firstTime) / state.duration));
      var eased = 1 - Math.pow(1 - progress, 3);
      write(state, progress === 1 ? state.target : Math.floor(state.target * eased));
      if (progress < 1) state.frame = requestFrame(tick);
      else finish(state);
    }
    // A primeira pintura da animacao sempre mostra zero.
    state.frame = requestFrame(tick);
  }

  function checkVisible() {
    checkFrame = 0;
    waiting.forEach(function (state) {
      if (!state.node.isConnected) remove(state);
      else if (inView(state)) start(state);
    });
  }

  function scheduleCheck() {
    if (waiting.size && !checkFrame) checkFrame = requestFrame(checkVisible);
  }

  function initialize(root) {
    if (!root.isConnected) return;
    var duration = limitedNumber(root.getAttribute('data-gm-duration'), 2200, 10000);
    root.querySelectorAll(COUNTER).forEach(function (node) {
      if (states.has(node)) return;
      var state = {
        node: node,
        root: root,
        target: Math.round(limitedNumber(node.getAttribute('data-gm-count-to'), 0, 100)),
        duration: duration,
        phase: 'waiting',
        frame: 0
      };
      states.set(node, state);
      if (duration === 0 || state.target === 0 || (motion && motion.matches)) {
        finish(state);
        return;
      }
      node.setAttribute('data-gm-counter-state', 'waiting');
      write(state, 0);
      waiting.add(state);
      if (intersection) intersection.observe(node);
    });
    root.setAttribute('data-gm-ready', 'true');
    scheduleCheck();
  }

  function collect(scope) {
    if (!scope) scope = document;
    if (scope.nodeType === 1 && scope.matches(ROOT)) initialize(scope);
    if (scope.querySelectorAll) scope.querySelectorAll(ROOT).forEach(initialize);
  }

  function prune() {
    states.forEach(function (state) {
      if (!state.node.isConnected || !state.root.contains(state.node)) remove(state);
    });
  }

  function refresh(scope) {
    if (!booted) return;
    prune();
    collect(scope || document);
    scheduleCheck();
  }

  function replay(scope) {
    if (!booted) return;
    scope = scope || document;
    states.forEach(function (state) {
      if (scope === document || scope === state.root || (scope.contains && scope.contains(state.node))) remove(state);
    });
    collect(scope);
    scheduleCheck();
  }

  window.GumellaPercentuaisV2 = {
    version: '2.0.0',
    refresh: refresh,
    replay: replay
  };

  function boot() {
    if (booted) return;
    booted = true;

    if (typeof window.IntersectionObserver === 'function') {
      intersection = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var state = states.get(entry.target);
          if (state && entry.isIntersecting && inView(state)) start(state);
        });
      }, { threshold: [0, 0.1], rootMargin: '0px 0px -24px 0px' });
    }

    collect(document);

    // O editor pode inserir o HTML sem executar scripts dentro do bloco.
    if (typeof window.MutationObserver === 'function') {
      mutations = new MutationObserver(function (records) {
        var removal = false;
        records.forEach(function (record) {
          if (record.type === 'attributes') {
            if (record.attributeName === 'data-gm-count-to' && states.has(record.target)) {
              var current = states.get(record.target);
              var currentRoot = current.root;
              remove(current);
              initialize(currentRoot);
            }
            if (record.attributeName === 'data-gm-duration' && record.target.matches(ROOT)) replay(record.target);
            scheduleCheck();
            return;
          }
          record.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return; // Ignora os textos atualizados pela propria contagem.
            collect(node);
            var root = node.closest(ROOT);
            if (root) initialize(root);
          });
          record.removedNodes.forEach(function (node) {
            if (node.nodeType === 1) removal = true;
          });
        });
        if (removal) prune();
        scheduleCheck();
      });
      mutations.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'data-gm-count-to', 'data-gm-duration']
      });
    }

    // Verificacao de reserva: funciona tambem sem IntersectionObserver.
    document.addEventListener('scroll', scheduleCheck, { passive: true, capture: true });
    window.addEventListener('resize', scheduleCheck, { passive: true });
    window.addEventListener('orientationchange', scheduleCheck, { passive: true });
    window.addEventListener('load', scheduleCheck, { once: true });
    window.addEventListener('pageshow', function () { refresh(); });
    document.addEventListener('visibilitychange', scheduleCheck);
    document.addEventListener('transitionend', scheduleCheck, true);
    document.addEventListener('animationend', scheduleCheck, true);

    document.addEventListener('shopify:section:load', function (event) { refresh(event.target); });
    document.addEventListener('shopify:section:reorder', scheduleCheck);
    document.addEventListener('shopify:section:unload', function (event) {
      states.forEach(function (state) {
        if (event.target.contains(state.node)) remove(state);
      });
    });
    document.addEventListener('shopify:section:select', function (event) {
      if (window.Shopify && window.Shopify.designMode) replay(event.target);
    });

    function motionChanged(event) {
      if (event.matches) states.forEach(finish);
      else scheduleCheck();
    }
    if (motion && motion.addEventListener) motion.addEventListener('change', motionChanged);
    else if (motion && motion.addListener) motion.addListener(motionChanged);

    // Reavaliacoes limitadas para fontes, imagens e efeitos de entrada do tema.
    [100, 400, 1000, 2200].forEach(function (delay) {
      window.setTimeout(scheduleCheck, delay);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleCheck);
    scheduleCheck();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
